const config = {
  local: {
    isProduction: false,
    host: "localhost",
    apiHost: "localhost",
    apolloWsHost: "ws://localhost:5001",
    apolloHost: "http://localhost:3030/api/graphql",
    wsHost: "localhost",
    port: 3000,
    apiPort: 3030,
    wsPort: 8081,
    webpackPort: 3001,
    protocol: "http",
    app: {
      name: "Lattix Sight Local Dev"
    },
    arango: {
      host: "localhost",
      port: 8529,
      db: "local",
      user: "root",
      password: "password"
    },
    recaptchaKey: "6LeyhTUUAAAAAH3CY_5fKnMA2DD3NFV5fiVTSB7T",
    avatarsHostname: "avatars.lattixsight.com",
    analyticsId: "UA-43866523-4",
    stripeKey: {
      public: "pk_test_3s4v8Gy5a288xJaNtkD3ybLG",
      secret: "sk_test_l7Dhv0Pm3I6JxKtSrcutdP6a"
    }
  },
  test: {
    isProduction: false,
    host: "localhost",
    apiHost: "localhost",
    apolloWsHost: "ws://localhost:1338",
    apolloHost: "http://localhost:1337/api/graphql",
    wsHost: "localhost",
    port: 3005,
    apiPort: 1337,
    wsPort: 1338,
    webpackPort: 3001,
    protocol: "http",
    app: {
      name: "Lattix Sight Test Dev"
    },
    recaptchaKey: "6LeyhTUUAAAAAH3CY_5fKnMA2DD3NFV5fiVTSB7T",
    avatarsHostname: "testing.lattixsight.com",
    analyticsId: "UA-43866523-4",
    stripeKey: {
      public: "pk_test_3s4v8Gy5a288xJaNtkD3ybLG",
      secret: "sk_test_l7Dhv0Pm3I6JxKtSrcutdP6a"
    }
  },
  beta: {
    isProduction: false,
    host: "beta.lattixsight.com",
    apiHost: "api.beta.lattixsight.com",
    apolloWsHost: "wss://api.beta.lattixsight.com",
    apolloHost: "https://api.beta.lattixsight.com/api/graphql",
    wsHost: "api.beta.lattixsight.com",
    port: 3000,
    apiPort: 3030,
    wsPort: 8081,
    protocol: "https",
    app: {
      name: "Sight Beta"
    },
    arango: {
      host: "172.31.17.171",
      port: 8529,
      db: "beta",
      user: "root",
      password: "password"
    },
    recaptchaKey: "6LcxiTUUAAAAALBss2-i9pzjiMejuxrATjJzBAlA",
    avatarsHostname: "avatars.lattixsight.com",
    analyticsId: "UA-43866523-4",
    stripeKey: {
      public: "pk_test_3s4v8Gy5a288xJaNtkD3ybLG",
      secret: "sk_test_l7Dhv0Pm3I6JxKtSrcutdP6a"
    }
  },
  development: {
    isProduction: false,
    host: "dev.lattixsight.com",
    apiHost: "dev.lattixsight.com",
    apolloWsHost: "dev.lattixsight.com:5000",
    wsHost: "dev.lattixsight.com",
    port: 3000,
    apiPort: 3030,
    wsPort: 8081,
    webpackPort: 3001,
    protocol: "http",
    app: {
      name: "Sight Development"
    },
    arango: {
      host: "172.31.17.171",
      port: 8529,
      db: "dev",
      user: "root",
      password: "password"
    },
    recaptchaKey: "6LeyhTUUAAAAAH3CY_5fKnMA2DD3NFV5fiVTSB7T",
    avatarsHostname: "avatars.lattixsight.com",
    analyticsId: "UA-43866523-4",
    stripeKey: {
      public: "pk_test_3s4v8Gy5a288xJaNtkD3ybLG",
      secret: "sk_test_l7Dhv0Pm3I6JxKtSrcutdP6a"
    }
  },
  staging: {
    isProduction: false,
    host: "staging.app.sightplanner.com",
    apiHost: "api.staging.app.sightplanner.com",
    apolloWsHost: "wss://api.staging.app.sightplanner.com",
    apolloHost: "https://api.staging.app.sightplanner.com/api/graphql",
    wsHost: "api.staging.app.sightplanner.com",
    port: 3000,
    apiPort: 3030,
    wsPort: 8081,
    protocol: "https",
    app: {
      name: "Sight Planner Staging"
    },
    arango: {
      host: "172.31.17.171",
      port: 8529,
      db: "beta",
      user: "root",
      password: "password"
    },
    recaptchaKey: "6Lf6NwoeAAAAAA4I6ihN2OcYEPnHESYM38mQhfbv",
    avatarsHostname: "avatars.staging.app.sightplanner.com",
    analyticsId: "UA-43866523-7",
    stripeKey: {
      public: "pk_test_3s4v8Gy5a288xJaNtkD3ybLG",
      secret: "sk_test_l7Dhv0Pm3I6JxKtSrcutdP6a"
    }
  },
  dev: {
    isProduction: true,
    host: "dev.lattixsight.com",
    apiHost: "api.dev.lattixsight.com",
    apolloWsHost: "wss://api.dev.lattixsight.com",
    apolloHost: "https://api.dev.lattixsight.com/api/graphql",
    wsHost: "dev.lattixsight.com",
    port: 3001 || process.env.CLIENT_PORT,
    apiPort: 3031 || process.env.API_PORT,
    wsPort: 8082,
    protocol: "https",
    app: {
      name: "Lattix Sight Production"
    },
    arango: {
      host: "172.31.17.171",
      port: 8529,
      db: "dev",
      user: "root",
      password: "password"
    },
    recaptchaKey: "6LeyhTUUAAAAAH3CY_5fKnMA2DD3NFV5fiVTSB7T",
    avatarsHostname: "avatars.lattixsight.com",
    analyticsId: "UA-43866523-4",
    stripeKey: {
      public: "pk_test_3s4v8Gy5a288xJaNtkD3ybLG",
      secret: "sk_test_l7Dhv0Pm3I6JxKtSrcutdP6a"
    }
  },
  production: {
    isProduction: true,
    host: "app.lattixsight.com",
    apiHost: "api.app.lattixsight.com",
    apolloWsHost: "wss://api.app.lattixsight.com",
    apolloHost: "https://api.app.lattixsight.com/api/graphql",
    wsHost: "app.lattixsight.com",
    port: 3000,
    apiPort: 3030,
    wsPort: 8081,
    protocol: "https",
    app: {
      name: "Sight Planner Production"
    },
    arango: {
      host: "172.31.17.171",
      port: 8529,
      db: "dev",
      user: "root",
      password: "password"
    },
    recaptchaKey: "6Lf6NwoeAAAAAA4I6ihN2OcYEPnHESYM38mQhfbv",
    avatarsHostname: "avatars.lattixsight.com",
    analyticsId: "UA-43866523-7",
    stripeKey: {
      public: "pk_test_3s4v8Gy5a288xJaNtkD3ybLG",
      secret: "sk_test_l7Dhv0Pm3I6JxKtSrcutdP6a"
    }
  }
}[process.env.REACT_APP_ENV || "local"];

if (process.env.CI_CONFIG === "true") { // built in gitlab - use variables from job
  config.host= process.env.SIGHTCLIENT_HOST;
  config.apiHost = process.env.SIGHTCLIENT_APIHOST;
  config.apolloWsHost = process.env.SIGHTCLIENT_APOLLOWSHOST;
  config.apolloHost = process.env.SIGHTCLIENT_APOLLOHOST;
  config.protocol = "https";
}

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js